import {OrderedMap, OrderedSet, Record} from 'immutable';
import type {RecordOf} from 'immutable';

import type {
  BlockType,
  CombinatorKey,
} from '@packages/systems/core/utils/StyleTypes';
import type {BreakpointID, StyleBlockId} from '@packages/systems/style/types';
import type {RawStyleBlockType} from '@packages/systems/style-legacy/values';
import type {Selector} from '@packages/systems/style-legacy/rules';
import type {PluginName, Qualified} from '@packages/systems/wfdl-Qualified';

export type StyleBlockVariant = OrderedMap<'styleLess', string>;

type StyleBlockShape = {
  _id: StyleBlockId;
  fake: boolean;
  type: BlockType;
  name: string;
  namespace: string;
  comb: CombinatorKey;
  styleLess: string;
  variants: OrderedMap<BreakpointID, StyleBlockVariant>;
  children: OrderedSet<string>;
  selector: Selector | null | undefined;
  createdBy?: string | null;
  pluginType?: PluginName;
  origin: null | Qualified<StyleBlockId>;
  get: (key: string) => any;
  getIn: (path: Array<string>) => any;
  set: (arg1: string, arg2?: any | null | undefined) => StyleBlock;
  setIn: (path: Array<string>, arg2?: any | null | undefined) => StyleBlock;
  update: (arg1: string, arg2: any) => StyleBlock;
  equals: (other?: any) => boolean;
  toJS: () => RawStyleBlockType;
};

export type StyleBlock = RecordOf<StyleBlockShape>;

export const StyleBlockRecord = Record<StyleBlockShape>(
  {
    // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'string'.
    _id: null,
    fake: false,
    // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'BlockType'.
    type: null,
    // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'string'.
    name: null,
    // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'string'.
    namespace: null,
    // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'CombinatorKey'.
    comb: null,
    // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'string'.
    styleLess: null,
    variants: OrderedMap<never, never>(),
    children: OrderedSet<never>(),
    // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'string | undefined'.
    pluginType: null,
    createdBy: null,
    origin: null,

    // TODO: Remove this and derive selector tokens via memoized function...
    selector: null,
  },
  'StyleBlockRecord'
);
